<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="container-fluid mb-5" style="background-color: #cbcaca !important;     margin-top: 0px;">
    <b-row style="background: #053672 !important">
      <b-col>
        <b-img
          src="https://dentalia.com/wp-content/themes/dentalia/dist/images/dentalia_logo.png"
          style="max-height: 6vw"
          alt="Dentalia"
        ></b-img>
      </b-col>
      <b-col> </b-col>
      <b-col class="mt-4" style="color: white">
        <h1>Facturación</h1>
      </b-col>
    </b-row>
    <b-row style="background: #cccc !important;">
      <b-col style="margin-top: 19vh" class="ml-5" cols="2">
        <label>
          Id de ticket: *
          <b-icon variant="primary" icon="question-circle-fill"  v-on:click="mostrarCert"> </b-icon>
        </label>
        <h1>{{idTicket2}}</h1>
        <!--<b-form-input
          type="number"
          v-model="idTicket"
          placeholder="Id ticket *"
          :state="idTicket != null && idTitular !== null"
          required
          @input="obtenerRfcTicketPaciente(1)"
          disabled="true"
        ></b-form-input>-->
        <span
          v-if="idTitular === null"
          style="color:red; !important; font-size:13px !important"
          >No existe Ticket</span
        >
        <span
          v-if="idTitular !== null"
          style="color: green !important; font-size: 13px !important"
          >Existe Ticket</span
        >
        <b-form-invalid-feedback :state="idTicket != null">
          El campo es requerido
        </b-form-invalid-feedback>

      </b-col>
      <b-col style="margin-top: 19vh" cols="4">
        <label
          >RFC*<b-spinner small class="mr-1" v-if="loaderTicket"></b-spinner
        ></label>
        <b-input-group>
          <b-form-select
            v-model="rfc"
            :options="listaRfcPaciente"
            value-field="rfc"
            text-field="rfc"
            :state="rfc != null"
            required
            @input="obtenerCodigoUsoFactura"
          >
          </b-form-select>
          <b-form-invalid-feedback :state="rfc != null">
            Debe seleccionar una opción
          </b-form-invalid-feedback>
        </b-input-group>
        <label v-if="rfcSeleccionado !== null" style="font-size: 12px"
          >Razón Social:{{ rfcSeleccionado.nombreRfc }}</label
        >
        <label v-if="rfcSeleccionado !== null" style="font-size: 12px"
          >Tipo Persona:{{ rfcSeleccionado.tipoRfc }}</label
        >
         <div class="mt-5">
              <b-button variant="outline-primary" v-if="enviando" disabled>
                <b-spinner small></b-spinner>
                Cargando...
              </b-button>

              <b-button variant="outline-primary" v-else @click=" crearFactura() ">
                Enviar
              </b-button>
              <b-button class="ml-1" variant="outline-success"
                        @click="agregar()">Agregar datos fiscales
              </b-button>
            </div>
      </b-col>
      <b-col style="margin-top: 19vh" cols="4">
        <label
          >Uso de CFDI*<b-spinner
            small
            class="mr-1"
            v-if="loaderCFDI"
          ></b-spinner
        ></label>
        <b-input-group>
          <b-form-select
            v-model="codigoUsoFactura"
            :options="listaCodigoFactura"
            value-field="codigo"
            text-field="descripcion"
            :state="codigoUsoFactura != null"
            required
          >
          </b-form-select>
          <b-form-invalid-feedback :state="codigoUsoFactura != null">
            Debe seleccionar una opción
          </b-form-invalid-feedback>
        </b-input-group>
      </b-col>
    </b-row>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <b-row style="background: #053672 !important">
        <b-col>
        <span style="color: white">
          Consulta nuestro
          <a
              class="underlineHover"
              href="https://dentalia.com/politica-privacidad/"
              target="_blank"
          >
            aviso de privacidad
          </a>
          en
          <a
              class="underlineHover"
              href="http://www.dentalia.com/"
              target="_blank"
          >
            dentalia.com
          </a>
        </span>
        </b-col>
      </b-row>
    </div>
<b-modal title="¡Recuerda!" visible style="background: #053672 !important;
    color: white !important;">
      <p>
        Para un mejor servicio ahora tienes 30 días naturales a partir de la
        fecha de tu consumo para solicitar tu factura. Recuerda que la fecha de
        la factura corresponde al día que la generas.
      </p>
      <template #modal-footer="{ ok }">
        <b-button  @click="ok()"> OK</b-button>
      </template>
    </b-modal>

    <b-modal
        ref="cert"
        title="Verifica tu certificado"
        size="xl"
        hide-footer>
      <div class="text-center">
        <p>Solo ingresa los dígitos del id de tu certificado</p>
      </div>
    </b-modal>


      <b-modal
        v-model="showModal"
        title="Agregar datos Fiscales"
        size="lg"
        centered
    >
    <div fluid>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group @input="listaFiscal"  id="tipo" v-model="datoFiscal.tipoPersona"
                                  name="tipo">
                <b-form-radio :value="2">Fisica</b-form-radio>
                <b-form-radio :value="1">Moral</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <label for="rfc">
                         <b-spinner small class="mr-1" v-if="loaderTicket"></b-spinner>idTicket
              </label>
             <!--<b-form-input
                    type="number"
                    v-model="idTicket2"
                    placeholder="Id ticket *"
                    :state="idTicket2 != null && idTitular2 !== null"
                    required
                    @input="obtenerRfcTicketPaciente(2)"
                    disabled="true"
                ></b-form-input>-->
            <h1>{{idTicket2}}</h1>
                <span v-if="idTitular2 === null" style="color:red; !important; font-size:13px !important">No existe Ticket</span>
                <span v-if="idTitular2 !== null" style="color:green !important; font-size:13px !important">Existe Ticket</span>
                <b-form-invalid-feedback :state="idTicket2 != null">
                  El campo es requerido
                </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="rfc">RFC
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="rfc" name="rfc" placeholder="RFC"
                v-model="datoFiscal.rfc"
                 @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                 maxLength="13"
                 :state="datoFiscal.rfc != null &&
                        datoFiscal.rfc.length >= 12"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
             <b-form-invalid-feedback
                        :state="
                        datoFiscal.rfc != null &&
                        datoFiscal.rfc.length >= 12
                      "
                    >
                      El campo es requerido
                    </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="regimen">Regimen Fiscal</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-select
                    id="regimen"
                    name="regimen"
                    placeholder="Regimen Fiscal"
                    v-model="datoFiscal.regimenFiscal"
                    :options="regimenFiscales"
                    value-field="idRegimenFiscal"
                    text-field="nombre"
                    :state="datoFiscal.regimenFiscal !== null"
                    required
                >
                </b-form-select>
              </b-input-group>
              <b-form-invalid-feedback :state="datoFiscal.regimenFiscal !== null">
                El campo es requerido
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <h5>Razón social</h5>
        <hr>
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="nombre">Nombre(s)
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                id="nombre" name="rfc" placeholder="Nombre"
                 v-model="datoFiscal.nombre"
                 @input="datoFiscal.nombre = datoFiscal.nombre.toUpperCase()"
                 :state="datoFiscal.nombre != null && datoFiscal.nombre.length >= 1"
                 minLength="1"
                 required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-invalid-feedback :state="datoFiscal.nombre != null && datoFiscal.nombre.length >= 3">
               El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 1">
          <b-col>
            <b-form-group>
              <label for="nombre">Nombre de la razón social
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input   
                 v-model="datoFiscal.nombreCompleto"
                 @input="datoFiscal.nombreCompleto = datoFiscal.nombreCompleto.toUpperCase()"
                 :state="datoFiscal.nombreCompleto != null && datoFiscal.nombreCompleto.length >= 1"
                 minLength="1"
                 required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
             <b-form-invalid-feedback :state="datoFiscal.nombreCompleto != null && datoFiscal.nombreCompleto.length >= 3">
               El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="paterno">Apellido paterno
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="paterno" name="paterno" placeholder="Apellido paterno"
                v-model="datoFiscal.paterno"
                 @input="datoFiscal.paterno = datoFiscal.paterno.toUpperCase()"
                 :state="datoFiscal.paterno != null && datoFiscal.paterno.length >= 1"
                 minLength="1"
                 required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-invalid-feedback :state="datoFiscal.paterno != null && datoFiscal.paterno.length >= 3">
               El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="materno">Apellido materno
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="materno" name="materno" placeholder="Apellido materno"
                 v-model="datoFiscal.materno"
                 @input="datoFiscal.materno = datoFiscal.materno.toUpperCase()"
                 
                 
                ></b-form-input>
              </b-input-group>
            </b-form-group>
             
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="correo">Correo electrónico
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="email" id="correo" name="correo" placeholder="Correo"
                          v-model="datoFiscal.correo"
                          :state="validMail(datoFiscal.correo)"
                          required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
                   <b-form-invalid-feedback :state="validMail(datoFiscal.correo)">
                    El campo es requerido
                  </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="cp">CP
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="cp" name="cp" placeholder="CP" type="number"
                 v-model="datoFiscal.cp"
                 :state="datoFiscal.cp != null && datoFiscal.cp.length === 5"
                 maxLength="5"
                 required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
              <b-form-invalid-feedback :state="datoFiscal.cp != null && datoFiscal.cp.length === 5">
               El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer">
               <b-button variant="outline-primary" :disabled="loaderAcciones && datoFiscal.rfc != null" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
         <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
        <b-modal
        v-model="showModalCerificado"
        title="Verifica tu certificado"
        size="xl"
        hide-footer>
      <div class="text-center">
        <p>Solo ingresa los dígitos del id de tu ticket</p>
        <img src="@/assets/imgCertificado.png" alt="imgCert" width="900"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { LoginService } from "@/apiServices/login/LoginService";
export default {
  name: "facturacionLineaPortal",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    rfc: null,
    idTicket: null,
    enviando: false,
    codigoUsoFactura: null,
    listaCodigoFactura: [],
    regimenFiscales: [],
    showModal: false,
    datoFiscal: {
      idPaciente: null,
      rfc: null,
      regimenFiscal: null,
      tipoPersona: 2,
      nombre: null,
      nombreCompleto: null,
      paterno: null,
      materno: null,
      cp: null,
      correo: null,
    },
    loaderAcciones: false,
    blntieneDatos: false,
    idTitular: null,
    listaRfcPaciente: [],
    idTitular2: null,
    idTicket2: null,
    rfcSeleccionado: null,
    loaderTicket: false,
    loaderCFDI: false,
    loginService: new LoginService(),
    showModalCerificado: false,
    token: null
  }),
    created() {
      this.debug = this.$localStorageService.getDebug();
      this.generarToken();
      this.token = this.$route.params.token;

    },
  methods: {
    listaFiscal() {
      const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
      this.$http.post(this.$api + 'catalogos/regimenFiscal/obtener/activo',parametros,{ headers: { Authorization: this.headers } }).then(respuesta => {
        if (respuesta.data.data) {
          this.regimenFiscales = respuesta.data.data;
        }
      }).catch((err) => {
        this.errorMensaje(err);
      });
    },
    generarToken() {
      this.loginService
        .login(
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_USER,
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_DATO
        )
        .then((response) => {
          this.headers = response.Authentication;
          this.obtenerTicketPorToken(this.token);
          this.listaFiscal();
        });
    },
    obtenerRfcTicketPaciente(tickeTipo) {
      this.loaderTicket = true;
      this.rfcSeleccionado = null;
      let tickeDinamico;
      if (tickeTipo === 1) {
        this.listaRfcPaciente = [];
        this.rfc = null;
        tickeDinamico = this.idTicket;
      } else {
        tickeDinamico = this.idTicket2;
      }
      const datos = {
        idTicket: tickeDinamico
      }
      const url =
        this.$api + "erp/portal/pacienteRfc"
      this.$http
        .post(url,datos, { headers: { Authorization: this.headers } })
        .then((respuesta) => {
          if (respuesta.data.data) {
            if (tickeTipo === 1) {
              this.listaRfcPaciente = respuesta.data.data.listarfcs;
              this.idTitular = respuesta.data.data.paciente;
            }
            if (tickeTipo === 2) {
              this.idTitular2 = respuesta.data.data.paciente;
            }
          }
        })
        .finally(() => {
          this.loaderTicket = false;
        });
    },
    guardar() {
      this.blntieneDatos = false;
      if (this.datoFiscal.tipoPersona === 2) {
        if (
          this.datoFiscal.nombre !== null &&
          this.datoFiscal.paterno !== null &&
          this.datoFiscal.rfc !== null &&
          this.datoFiscal.regimenFiscal !== null &&
          this.datoFiscal.rfc.length >= 12 &&
          this.datoFiscal.correo !== null &&
          this.validMail(this.datoFiscal.correo) &&
          this.datoFiscal.cp !== null &&
          this.datoFiscal.cp.length === 5
        ) {
          this.datoFiscal.nombreCompleto =
            this.datoFiscal.nombre.trim() +
            " " +
            this.datoFiscal.paterno.trim() +
            " " +
            this.datoFiscal.materno;
          this.blntieneDatos = true;
        }
      } else if (this.datoFiscal.tipoPersona === 1) {
        if (
          this.datoFiscal.nombreCompleto !== null &&
          this.datoFiscal.cp !== null &&
          this.datoFiscal.cp.length === 5 &&
          this.datoFiscal.rfc !== null &&
          this.datoFiscal.rfc.length >= 12 &&
          this.datoFiscal.regimenFiscal !== null &&
          this.datoFiscal.correo !== null &&
          this.validMail(this.datoFiscal.correo)
        ) {
          this.blntieneDatos = true;
        }
      }
      if (this.blntieneDatos) {
        this.datoFiscal.idPaciente = this.idTitular2;
        this.loaderAcciones = true;
        this.nombre();
        this.$http
          .post(
            this.$api + "fiscales/guardar/datosFiscales",
            this.datoFiscal,
            { headers: { Authorization: this.headers } }
          )
          .then((respuesta) => {
            if (respuesta.data.data.idDatosFiscales !== null) {
              this.showModal = false;
              this.obtenerRfcTicketPaciente(1);
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Los datos se guardó correctamente",
              });
            }
          })
          .catch((reason) => {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: reason.response.data.message,
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    nombre() {
      if (this.datoFiscal.tipoPersona === 1) {
        this.datoFiscal.nombre = "";
        this.datoFiscal.paterno = "";
        this.datoFiscal.materno = "";
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimStart();
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimEnd();
      } else {
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimStart();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimStart();
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimEnd();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimEnd();
        if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trimStart();
          this.datoFiscal.materno = this.datoFiscal.materno.trimEnd();
        }
      }
    },
    agregar() {
      this.datoFiscal = {
        idPaciente: null,
        rfc: null,
        regimenFiscal: null,
        tipoPersona: 2,
        nombre: null,
        nombreCompleto: null,
        paterno: null,
        materno: null,
        cp: null,
        correo: null,
      };
      this.showModal = true;
    },
    cerrarModal() {
      this.showModal = false;
    },
    crearFactura() {
      this.enviando = true;
      const url = this.$api +"erp/portal/facturacion";
      let parametros = {
        rfc: this.rfc.toUpperCase(),
        idTicket: this.idTicket,
        usoFactura: this.codigoUsoFactura,
        fechaFactura: this.$moment(new Date()).format("YYYY-MM-DD"),
        idTitular: this.idTitular,
        horas: this.$horas(),
      };
      this.$http
        .post(url, parametros,  { headers: { Authorization: this.headers } })
        .then((response) => {
          if (response.status == 200 && response.data.data.error === false) {
            window.open(response.data.data.ligaFactura, "_blank");
            this.$swal({
              icon: "success",
              text: `${response.data.data.mensaje}`,
              confirmButtonText: "OK",
            })
          } else {
            this.mostrarMensaje(response.data.data.mensaje);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    mostrarMensaje(mensaje) {
      this.$swal({
        icon: "error",
        text: `${mensaje}`,
        confirmButtonText: "OK",
      });
    },
    obtenerTicketPorToken(token) {
      let parametros = {
        nombrePaciente: null,
        emailToken: token
      };
      const url = this.$api +"erp/portal/ticket";
      this.$http
          .post(url, parametros,  { headers: { Authorization: this.headers } })
          .then((response) => {
            this.idTicket = response.data.data;
            this.idTicket2 = response.data.data;
            this.obtenerRfcTicketPaciente(1);
            this.obtenerRfcTicketPaciente(2);
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
          });
    },
    validMail(email) {
      var expr =
        /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      return expr.test(email);
    },
    obtenerCodigoUsoFactura() {
      this.codigoUsoFactura = null;
      this.listaCodigoFactura = [];
      let fisica;
      let moral;
      if (this.rfc.length === 13) {
        fisica = true;
        moral = false;
      } else if (this.rfc.length === 12) {
        fisica = false;
        moral = true;
      }
      this.rfcSeleccionado = this.listaRfcPaciente.find(
        (r) => r.rfc === this.rfc
      );
      if (this.rfc.length >= 12) {
        this.loaderCFDI = true;
        const datos = {
          personaFisica: fisica,
          personaMoral: moral
        }
        const url =
          this.$api +"erp/portal/codigoUsoFactura"
        this.$http
          .post(url, datos, { headers: { Authorization: this.headers } })
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaCodigoFactura = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loaderCFDI = false;
          });
      }
    },
     mostrarCert() {
      this.showModalCerificado = true;
     }
  },
};
</script>

<style>
.modal-header {
    background: #053672 !important;
    color: white !important;
}
</style>
